/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Application,
  Sidebar,
  Dropdown,
} from '@cgn/framework-ui-components/v1';
import { MenuUtente } from '@cgn/framework-ui-components/v2';
import {
  MessaggiNavbarIcon,
  QuestionMarkIcon,
  ChiusiIcon,
  MyCgnIcon,
  BusinessContactIcon,
  BusinessContactsIcon,
  Logo30,
} from '@cgn/framework-ui-components/icons';
import Tour from './Shared/Tour';
import MenuInterno from './MenuInterno';
import WithHistory from './Shared/WithHistory';

// eslint-disable-next-line no-var, no-multi-assign
var div = (div = document.createElement('div'));
document.body.appendChild(div);

let f = true;
function caricaMenuHome(u, t, c, l) {
  if (f) {
    f = false;
    const e = document.createElement('script');
    e.type = 'text/javascript';
    e.src = `${u}/App/dist/browser-export.js`;
    e.async = false;
    e.defer = false;
    e.onload = function onload() {
      window.inizializzaMenuHome(u, t, c, l);
    };
    const h = document.getElementsByTagName('head')[0];
    h.insertBefore(e, h.lastChild);
  }
}

class App extends Component {
  static propTypes = {
    impostaUfficioSelezionato: PropTypes.func,
    messaggiDaLeggere: PropTypes.number,
    profilo: PropTypes.any,
    quesitiDaLeggere: PropTypes.number,
    ufficioSelezionato: PropTypes.string,
  };

  state = {
    mostraTour: false,
    slide: 1,
  };

  componentDidMount() {
    caricaMenuHome(
      window.urlHome,
      this.props.profilo.AccountId,
      this.props.ufficioSelezionato,
      document.getElementById('menuHomePlaceHolder'),
    );
  }

  apriAssistente() {
    window.open(
      `${window.UrlAssistente
      }/Permalink/Guida?aliasArea=MYC&codiceUfficio=${this.props.ufficioSelezionato}`,
      '_blank',
    );
  }

  onSlideChange = (s) => {
    this.setState({ slide: s });
  };

  onTourEnd = (onEnd) => {
    this.setState({ mostraTour: false });
  };

  render() {
    const totale = this.props.quesitiDaLeggere + this.props.messaggiDaLeggere;
    return (
      <Application>
        <Application.Header flow>
          <span id="menuHomePlaceHolder" />
          <Application.Separator />
          <Application.Title>
            <Logo30 className="appIconTitle" />
            <MyCgnIcon className="appIconTitle" />
          </Application.Title>
          <Application.Gap />
          <MenuUtente
            accountsUrl={window.UrlAccounts}
            myCgnUrl={window.UrlPortaleUnico}
            onUfficioChange={this.props.impostaUfficioSelezionato}
            utente={{
              nome: this.props.profilo.Nome,
              cognome: this.props.profilo.Cognome,
            }}
            ufficioSelezionato={this.props.ufficioSelezionato}
            uffici={this.props.profilo.Uffici.map((x) => x.CodiceUfficio)}
          />
          <WithHistory
            element={MenuInterno}
            totale={totale}
            utente={this.props.profilo}
            ufficio={this.props.ufficioSelezionato}
            container={div}
          />
          <Dropdown
            classPrefix="navDropDown"
            toggleComponent={<QuestionMarkIcon className="navbarIcon" />}
          >
            <Dropdown.Item onClick={() => this.apriAssistente()}>
              Assistente
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => this.setState({ mostraTour: true, slide: 1 })}
            >
              Vedi tour
            </Dropdown.Item>
          </Dropdown>
        </Application.Header>
        <Application.Body>
          <Sidebar>
            <Sidebar.Menu>
              <Sidebar.Item
                icon={<BusinessContactIcon />}
                onClick={() => (window.location.href = `${window.UrlPortaleUnico}#/ufficio/${this.props.ufficioSelezionato}`)}
              >
                Profilo personale
              </Sidebar.Item>
              <Sidebar.Item icon={<MessaggiNavbarIcon />} active>
                Quesiti e messaggi
              </Sidebar.Item>
              <Sidebar.Item
                icon={<BusinessContactsIcon />}
                onClick={() => (window.location.href = `${window.UrlPortaleUnico}#/gestioneUtentiUfficio/${this.props.ufficioSelezionato}`)}
              >
                Gestione utenti
              </Sidebar.Item>
              <Sidebar.Item
                icon={<ChiusiIcon />}
                onClick={() => (window.location.href = `${window.UrlPortaleUnico}#/privacycgn/${this.props.ufficioSelezionato}`)}
              >
                Privacy CGN
              </Sidebar.Item>
            </Sidebar.Menu>
            <Sidebar.Body>{this.props.children}</Sidebar.Body>
          </Sidebar>
        </Application.Body>
        {this.state.mostraTour && (
          <Tour
            slides={[
              './Content/images/ImmaginiTour/tour-mycgn-01.png',
              './Content/images/ImmaginiTour/tour-mycgn-02.png',
              './Content/images/ImmaginiTour/tour-mycgn-03.png',
              './Content/images/ImmaginiTour/tour-mycgn-04.png',
              './Content/images/ImmaginiTour/tour-mycgn-05.png',
              './Content/images/ImmaginiTour/tour-mycgn-06.png',
              './Content/images/ImmaginiTour/tour-mycgn-07.png',
            ]}
            slide={this.state.slide}
            onEnd={(end) => this.onTourEnd(end)}
            onChange={(s) => this.onSlideChange(s)}
          />
        )}
      </Application>
    );
  }
}

const mapStateToProps = (state) => ({
  profilo: state.profilo,
  ufficioSelezionato: state.ufficioSelezionato,
  quesitiDaLeggere: state.quesitiDaLeggere,
  messaggiDaLeggere: state.messaggiDaLeggere,
});

const mapDispatchToProps = (dispatch) => ({
  impostaUfficioSelezionato: (ufficioSelezionato) => {
    window.modificaUfficioCorrenteMenuHome
      && window.modificaUfficioCorrenteMenuHome(ufficioSelezionato);
    dispatch({
      type: 'IMPOSTA_UFFICIO_SELEZIONATO',
      ufficioSelezionato,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
